export const addTailwindModifier = (modifier, styleEnum) => {
	const generatedEnum = {};
	for (const [key, value] of Object.entries(styleEnum)) {
		generatedEnum[key] = modifier + value;
	}

	return Object.freeze(generatedEnum);
};

export const generateEnumByScreenSize = (screenSizeEnum, stylingEnum) => {
	const generatedEnum = {};

	for (const [screenSizeKey, screenSizeValue] of Object.entries(screenSizeEnum)) {
		for (const [key, value] of Object.entries(stylingEnum)) {
			generatedEnum[`${screenSizeKey}_${key}`] = value
				.split(' ')
				.map(s => screenSizeValue + s)
				.join(' ');
		}
	}

	return Object.freeze(generatedEnum);
};
